enum ReceiverAction {
    DELETE,
    EDIT,
}

export default ReceiverAction;
